import { render, staticRenderFns } from "./GuessBoard.vue?vue&type=template&id=bf349688&scoped=true&"
import script from "./GuessBoard.vue?vue&type=script&lang=js&"
export * from "./GuessBoard.vue?vue&type=script&lang=js&"
import style0 from "./GuessBoard.vue?vue&type=style&index=0&id=bf349688&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf349688",
  null
  
)

export default component.exports